export type SocialState = SocialStatus & SocialData;

export interface SocialStatus {
    loading: boolean;
    error: string | null;
}

export interface SocialData {
    videos: SocialVideos;
    podcasts: any[];
    accounts: any[];
    posts: any[];
}

export interface SocialVideos {
    liveVideos: any[];
    trendingVideos: any[];
    recommendedVideos: any[];
}

export const SOCIAL_VIDEOS_INIT: SocialVideos = {
    liveVideos: [],
    trendingVideos: [],
    recommendedVideos: []
}

export const SOCIAL_STATE_INIT: SocialState = {
    videos: {... SOCIAL_VIDEOS_INIT},
    podcasts: [],
    accounts: [],
    posts: [],
    loading: false,
    error: null
}